import React from "react";
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  '@keyframes fill': {
    from: { width: "0" },
    to: { width: "100%" }
  },
  bar: {
    background: theme.palette.grayBg,
    borderRadius: "2px",
    height: "8px",
    overflow: "hidden",
    position: "relative"
  },
  fillBar: {
    animation: "$fill 2s ease",
    backgroundColor: theme.palette.greenMain,
    borderRadius: "2px",
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "0",
    right: "0"
  },
  fillOuter: {
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "0"
  },
  container: {
    marginBottom: "19px"
  }
})

/**
 * Display animated grows progress bar
 * @name ProgressBar
 * @param {object} props React component properties
 * @param {string} [props.className] CSS-class of container
 * @param {string} [props.curValue] Filled value on bar
 * @param {string} [props.maxValue] Maximum value on bar
 * @example
 * return (
 *  <ProgressBar curValue = { "28" } 
 *               maxValue = { "100" } />
 * )
*/

const ProgressBar = (props) => {
  const { classes, className } = props;
  
  const maxValue = parseFloat(props.maxValue || "1");
  let curValue = parseFloat(props.curValue || "0");
  if(curValue > maxValue) {
    curValue = maxValue;
  }

  const fillWidth = ( curValue * 100 ) / maxValue

  return(
    <div className = { clsx(classes.container, className) } >
      <div className = { classes.bar }>
        <div className = { classes.fillOuter }
             style = {{ width: `${fillWidth}%` }}>
          <div className = { classes.fillBar }></div>      
        </div>
      </div>
    </div>
  )
}
export default withStyles(styles)(ProgressBar);